const PELLETS_STORAGE_KEYS = {
  zipCode: "pelletsZipCode",
  amount: "pelletsAmount",
} as const;

export interface PelletsPreset {
  zipCode: string | null;
  amount: number | null;
}

export function readPelletsPreset(minAmount: number): PelletsPreset {
  if (typeof localStorage === "undefined") {
    return { zipCode: null, amount: null };
  }

  const rawZip = localStorage.getItem(PELLETS_STORAGE_KEYS.zipCode);
  const zipCode = rawZip?.length === 5 ? rawZip : null;

  const rawAmount = Number(localStorage.getItem(PELLETS_STORAGE_KEYS.amount));
  const amount = rawAmount && rawAmount >= minAmount ? rawAmount : null;

  return { zipCode, amount };
}

export function writePelletsPreset(zipCode: string, amount: number): void {
  if (typeof localStorage === "undefined") return;

  if (/^\d{5}$/.test(zipCode)) {
    localStorage.setItem(PELLETS_STORAGE_KEYS.zipCode, zipCode);
  }
  localStorage.setItem(PELLETS_STORAGE_KEYS.amount, amount.toString());
}

export function getPelletsStorageKeys(): typeof PELLETS_STORAGE_KEYS {
  return PELLETS_STORAGE_KEYS;
}
